import React, { useState } from "react";
import "./cover.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import GlobalContext from "../../../contexts/globalContext";
import { GatsbyImage } from "gatsby-plugin-image";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { findRel } from "../../../shared/utils/stringUtilities";
import Button from "../button/button";
import { Link } from "gatsby";

const Cover = (props: ReferenciaContenido) => {
  const refPlantilla = props.referenciaPlantillaContenido;
  const settings = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    beforeChange: (_: number, next: number) => setSliderIndex(next),
  };
  const [slider, setSlider] = useState<any>();
  const [sliderIndex, setSliderIndex] = useState(0);
  const goToNext = () => {
    if (sliderIndex < refPlantilla.length - 1) {
      setSliderIndex(sliderIndex + 1);
      slider.slickNext();
    }
  };

  const goToBack = () => {
    if (sliderIndex > 0) {
      setSliderIndex(sliderIndex - 1);
      slider.slickPrev();
    }
  };

  const isHttp = (url?: string) => {
    return url?.startsWith("http");
  };

  //console.log(refPlantilla);

  const isActiveBack = () => sliderIndex > 0;

  const isActiveNext = () => sliderIndex < refPlantilla.length - 1;

  const colors = [
    "rgb(166, 171, 248)",
    "rgb(255, 152, 150)",
    "rgb(123, 222, 208)",
    "rgb(248, 186, 46)",
  ];

  //console.log(props);

  return (
    <GlobalContext.Consumer>
      {(data) =>
        data.userInfoContext.data?.userHaveTransaction === false ||
        data.userInfoContext.data?.userHaveTransaction === undefined ||
        props.nombreCategoria === "Empresas" ? (
          <div className="a-banner">
            <div className="a-banner-container">
              <Slider
                ref={(c) => {
                  setSlider(c);
                }}
                {...settings}
              >
                {refPlantilla.map((value, key) => {
                  const raw = JSON.parse(value?.descripcion?.raw);
                  console.log(value, "values");
                  return (
                    <div key={key}>
                      <div className="position-relative">
                        <GatsbyImage
                          className="a-fit_img"
                          image={value.imagenPrincipal[0]?.gatsbyImageData}
                          alt={
                            value.imagenPrincipal[0].title
                              ? value.imagenPrincipal[0].title
                              : "Banner principal"
                          }
                        />
                        <div className="container">
                          <div className="a-cover-desc">
                            <a
                              className={"hide-on-mobile"}
                              href={value.redireccionBoton}
                              target={
                                isHttp(value.redireccionBoton)
                                  ? "_blank"
                                  : "_self"
                              }
                              rel={findRel(value.redireccionBoton)}
                            >
                              {value.descripcion.raw &&
                                raw.content[1].content[0].content[0].content[0]
                                  .value}
                            </a>
                            <p
                              className={`a-cover-h1 title-primary ${
                                key == 0 ? "hide-on-mobile" : ""
                              }`}
                            >
                              {value.tituloBanner}
                            </p>
                            <p className="a-cover-h1 text-baner">
                              {value.descripcion.raw &&
                                raw.content[0].content[0].value}
                            </p>
                            {value.tituloBoton ? (
                              <Button
                                type="link"
                                text={value.tituloBoton}
                                classname={`secondary __mobilecolor
                                }`}
                                gtmMark={`gtmRedDeAmorBanner${normalizeTwoWords(
                                  value.tituloBoton
                                )}BannerPrincipal`}
                                href={value?.redireccionBoton}
                                isDisabled={false}
                                onClickAction={data.gigyaContext.login}
                              />
                            ) : (
                              <div className="a-cover-buttons">
                                {raw?.content[1]?.content.map((ele, idx) => {
                                  if (idx > 2) {
                                    return (
                                      <div
                                        className="a-cover-buttons-btn"
                                        style={{
                                          background: `${colors[idx - 3]}`,
                                        }}
                                      >
                                        <Link
                                          to={`${ele.content[0]?.content[1]?.data?.uri}`}
                                          rel={findRel(
                                            ele.content[0]?.content[1]?.data
                                              ?.uri
                                          )}
                                          target={
                                            isHttp(
                                              ele.content[0]?.content[1]?.data
                                                ?.uri
                                            )
                                              ? "_blank"
                                              : "_self"
                                          }
                                          className={``}
                                        >
                                          <h3>
                                            {ele.content[0]?.content[0].value}
                                          </h3>
                                        </Link>
                                      </div>
                                    );
                                  }
                                })}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* <div className="a-cover-foot hide-on-mobile">
                        <p>
                          <strong>
                            {value.descripcion &&
                              value.descripcion.json.content[1]?.content[1]
                                ?.content[0]?.content[0]?.value}
                          </strong>
                          |
                          <span>
                            {value.descripcion &&
                              value.descripcion.json.content[1]?.content[1]
                                ?.content[0]?.content[1]?.value}
                          </span>
                        </p>
                        <div className="linea" />
                        <span>
                          {value.descripcion &&
                            value.descripcion.json.content[1]?.content[2]
                              ?.content[0]?.content[0]?.value}
                        </span>
                      </div> */}
                    </div>
                  );
                })}
              </Slider>
              {/*<div className="a-cover-icons">
                <button
                  className={`a-icon-arrow gtmRedDeAmorBannerAdelantePrincipalBanner`}
                  onClick={previous}
                >
                  <div className="imagenLeft" />
                </button>
                <button
                  className="a-icon-arrow gtmRedDeAmorBannerAtrasPrincipalBanner"
                  onClick={next}
                >
                  <div className="imagenRigth" />
                </button>
              </div>
              */}
              <div className="arrow-content">
                <div className="arrows">
                  <div className="arrows-contain">
                    {
                      <>
                        <span
                          className={`direction ${
                            isActiveBack() ? "active" : ""
                          }`}
                          onClick={goToBack}
                        >
                          {"Atrás"}
                        </span>
                        <div
                          className={`arrow icon-arrow-light-left  ${
                            isActiveBack() ? "active" : ""
                          }`}
                          onClick={goToBack}
                        />
                      </>
                    }
                    {
                      <>
                        <div
                          className={`arrow icon-arrow-light-right  ${
                            isActiveNext() ? "active" : ""
                          }`}
                          onClick={goToNext}
                        />
                        <span
                          className={`direction ${
                            isActiveNext() ? "active" : ""
                          }`}
                          onClick={goToNext}
                        >
                          {"Siguiente"}
                        </span>
                      </>
                    }
                  </div>
                  <span className="direction-mobile active" onClick={() => {}}>
                    {""}
                  </span>
                  <span className="counter">
                    {sliderIndex + 1} / {refPlantilla.length}
                  </span>
                </div>
                {refPlantilla[sliderIndex].tituloDescripcion && (
                  <div className="text">
                    {refPlantilla[sliderIndex].tituloDescripcion}
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : null
      }
    </GlobalContext.Consumer>
  );
};
export default Cover;
